import React, { useContext } from "react";
import BasicAccountApplicationAPI from "../../api/commercial/basic-account-application";
import { ApplicationFlowSteps } from "../../route/application/authenticated/application-flow/types";
import { ErrorContext } from "../../route/error/provider";
import CompanyMapper from "../home/company-mapper";
import { CompanyModel } from "../home/types";
import PowerOfAttorney from "./index";
import PowerOfAttorneyMapper from "./mapper";
import { PowerOfAttorneyModel } from "./types";
import { BasicAccountApplicationDocument } from "../../api/commercial/generated-types";

export default function PowerOfAttorneyAdapter({
  basicAccountApplication,
  triggerReload,
  setStep,
}: {
  basicAccountApplication: BasicAccountApplicationDocument;
  triggerReload: () => void;
  setStep: (step: ApplicationFlowSteps) => void;
}): React.JSX.Element {
  const powerOfAttorneyModel: PowerOfAttorneyModel =
    PowerOfAttorneyMapper.mapDocumentToPageModel(basicAccountApplication);

  const companyModel: CompanyModel = CompanyMapper.mapDocumentToPageModel(
    basicAccountApplication.company,
  );

  const { setError } = useContext(ErrorContext);

  const selectedProduct = basicAccountApplication.productRef;
  return (
    <PowerOfAttorney
      initial={powerOfAttorneyModel}
      context={{
        selectedProduct,
        companyName: companyModel.name,
        basicAccountApplication: basicAccountApplication.applicationRef,
        pdfLanguage: basicAccountApplication.pdfLanguage,
      }}
      previous={() => {
        setStep(ApplicationFlowSteps.REGULATORY_INFORMATION);
      }}
      next={async (model: PowerOfAttorneyModel) => {
        try {
          const request = PowerOfAttorneyMapper.mapPageModelToRequest(
            model,
            basicAccountApplication.applicationRef,
          );
          await BasicAccountApplicationAPI.createPowerOfAttorney(request);
        } catch (error) {
          setError(error);
        }
        triggerReload();
      }}
    />
  );
}
